import { boot } from "@kit/boot";
import { BG } from "@kit/ui";
import { game } from "./index";

boot({ id: game.meta.id, scenes: game.scenes, background: BG });
